module.exports = __webpack_public_path__ + "files/9f439199fb08ab3dadb90cc5a229886d.png";